module.exports = __webpack_public_path__ + "img/broom.657d7b73.svg";